import React, { useState } from 'react'
import { LeadNotifyMessagingWrapper, LeadNotifyButtonWrapper, LeadNotifyWrapper } from "./LeadDetailsNotification.styled";
import { CloseOutlined, SendOutlined, MessageFilled } from '@ant-design/icons';
import ChatIcon from "../../../assets/svg/hipchat.svg"
import ChatThrowIcon from "../../../assets/svg/chat-throw.svg"
import { Input } from 'components/common';
import moment from 'moment';

const LeadDetailsNotification = ({ notifications, sendNotification, isNotificationOpen, setIsNotificationOpen }) => {
    const [message, setMessage] = useState("");
    const submitNotification = () => {
        if (!message) {
            return;
        }
        sendNotification(message);
        setMessage('');
    }
    return (
        <LeadNotifyWrapper>
            {isNotificationOpen && (<LeadNotifyMessagingWrapper>
                <div className="close-button" onClick={() => setIsNotificationOpen(false)}>
                    <CloseOutlined style={{ color: 'white', fontSize: 14 }} />
                </div>
                <div className="floating-title-container">
                    <div className="floating-title">
                        Notes
                    </div>
                </div>
                <div className="notes-body">
                    {notifications && notifications.length ? (
                        <>
                            {notifications.map((noti) => (
                                <div className="message-box">
                                    <div className="notes">
                                        <div className="icon">
                                            <img src={ChatIcon} alt="Chat Icon" />
                                        </div>
                                        <div className="note">{noti.message}</div>
                                    </div>
                                    <div className="dates">
                                        <span className="date">{moment(noti?.createdAt).format('DD-MM-YYYY')}</span>
                                        <span className="time">{moment(noti?.createdAt).format('hh:mm A')}</span>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : null}
                </div>
                <hr />
                <div className="messaging-box-input">
                    <input className="message" type="text" value={message} onChange={(event) => setMessage(event.target.value)} placeholder="Enter Message" />
                    <button className="send-button" onClick={submitNotification}>
                        <img src={ChatThrowIcon} alt="Send Chat Icon" />
                    </button>
                </div>
            </LeadNotifyMessagingWrapper>)}
        </LeadNotifyWrapper>
    )
}

export default LeadDetailsNotification;
